import { API, Auth, graphqlOperation } from "aws-amplify";
import { getUserProfile } from "../graphql/queries";

const getUserProfileWorker = async () => {
  try {
    const data = await Auth.currentAuthenticatedUser();

    const id = data.attributes.sub;

    const variables = {
      id,
    };
    const userProfileData = await API.graphql(
      graphqlOperation(getUserProfile, variables)
    );
    return userProfileData.data.getUserProfile;
  } catch (e) {
    return null;
  }
};

export default getUserProfileWorker;
